/**
 * Window event Settings dispatches to open the Send Feedback modal; Index
 * listens for it. Kept apart from SendFeedbackModal so the home page can
 * listen without loading the modal (and zod) until it is actually opened.
 */
export const FEEDBACK_OPEN_EVENT = "coe-feedback-open";
